<template>
    <div class="row">
        <snappy-table
                :endpoint="'vessels/' + vesselId + '/activities/stream/recent-contacts'"
                :columns="['type','campaign','created_at']"
                :headings="['Activity','Campaign','Created']"
                :templated-slot-names="['type','campaign']"
                table-class="contact-edit-recent-contact-activities"
                :filter-values="filterValues"
                :template-methods="columnTemplates(timezone)"
                :filterable-columns="['type','campaign', 'created_at']"
                :default-params="{'contact_id': contactId, 'activity_type_ids[]': [4, 6, 22, 24, 30]}"
                :filter-params-mapper="{type: 'activity_type_ids[]'}"
                record-type="Activities"
        >
            <template #type="{ row }">
                <div v-if="row.activity_type === 'clicks'">
                    <span class="label label-clicks">
                        <i class="fas fa-bullseye" aria-hidden="true"></i>
                        &nbsp;Clicked {{ row.step }}
                    </span>
                    <span v-if="row.url" class="activityClickUrl" v-tooltip="row.url">&nbsp;<a :href="row.url" target="_blank">{{ row.url }}</a></span>
                </div>
                <div v-else-if="row.activity_type === 'opens'">
                    <span class="label label-opens">
                         <i class="fas fa-envelope" aria-hidden="true"></i>
                        &nbsp;Opened {{ row.step }}
                    </span>
                </div>
                <div v-else-if="row.activity_type === 'views'">
                    <span class="label label-views">
                        <i class="fas fa-eye" aria-hidden="true"></i>
                        &nbsp;Viewed {{ row.step }}
                    </span>
                </div>
                <div v-else-if="row.activity_type === 'form-submissions'">
                    <span class="label label-form">
                        <i class="fas fa-file-alt" aria-hidden="true"></i>
                        &nbsp;Completed {{ row.step }} Form
                    </span>
                </div>
                <div v-else-if="row.activity_type === 'emails'">
                    <span class="label label-email">
                        <i class="fas fa-envelope" aria-hidden="true"></i> &nbsp;Sent Email
                    </span><br />
                    <span>
                        <strong>{{ row.step }}</strong> to
                        <span v-if="typeof row.contact.name !== 'undefined' && row.contact.name !== ''">
                            {{ row.contact.name }}
                        </span>
                        <span v-else>{{ row.contact.email }}</span>
                    </span>
                </div>
                <div v-else-if="row.activity_type === 'social-posts' && typeof row.meta !== 'undefined'">
                    <div v-if="row.meta.network === 'facebook-page-posts'">
                        <span class="label label-facebook">
                            <i class="fab fa-facebook" aria-hidden="true"></i> &nbsp;Posted to Facebook Page
                        </span><br />
                    </div>
                    <div v-else-if="row.meta.network === 'twitter-personal-posts'">
                         <span class="label label-twitter">
                             <i class="fab fa-twitter" aria-hidden="true"></i> &nbsp;Posted to Twitter Profile
                         </span><br />
                    </div>
                    <div v-else-if="row.meta.network === 'linkedin-personal-posts'">
                        <span class="label label-linkedin">
                            <i class="fab fa-linkedin" aria-hidden="true"></i> &nbsp;Posted to LinkedIn Profile
                        </span><br />
                    </div>
                </div>
                <div v-else>
                    {{ row.activity_type }}
                </div>
            </template>

            <template #campaign="{ row }">
                {{ row.campaign }} <span class="label label-id">ID: {{ row.campaign_id }}</span>
            </template>
        </snappy-table>
    </div>
</template>

<script>
import SnappyTable from '../../components/SnappyTable';
import columnTemplates from "../../mixins/tables/columnTemplates";
import {getVesselCampaigns} from '../../utility/api/campaign/getVesselCampaigns';

export default {
        name: 'contact-edit-contact-activities-table',
        components: {SnappyTable},
        mixins: [columnTemplates],
        data() {
            return {
                filterValues: {
                    type: [
                        {
                            id: 24,
                            text: 'Email Opens'
                        },
                        {
                            id: 22,
                            text: 'Page Views'
                        },
                        {
                            id: 4,
                            text: 'Link Clicks'
                        },
                        {
                            id: 6,
                            text: 'Form Submissions'
                        }
                    ],
                    campaign: []
                },
            };
        },
        methods: {
            setCampaignOptions() {
                getVesselCampaigns().then( (campaigns) => {
                    campaigns.forEach( (campaign) => {
                        this.filterValues.campaign.push({ id : campaign.id, text : campaign.name + " (ID: "+ campaign.id +")" });
                    });
                });
            },
            campaignToken: function(campaignId) {
                return btoa('campaign_id=' + campaignId);
            },
        },
        props: {
            vesselId: {
                type: Number,
                required: true
            },
            contactId: {
                type: Number,
                required: true
            },
            timezone: {
                type: String,
                required: true
            }
        },
        mounted() {
            this.setCampaignOptions();
        }
    }
</script>